import api from './api';
import { Store } from '../types/store';

export function getStores() {
    return api.get<{ data: Store[] }>('/stores');
}

export function syncStoresFromPo() {
    return api.post('/stores/sync-po');
}

// Add more store-related API functions as needed
export function getStore(id: number) {
    return api.get<{ data: Store }>(`/stores/${id}`);
}

export function createStore(data: Omit<Store, 'id'>) {
    return api.post<{ data: Store }>('/stores', data);
}

export function updateStore(id: number, data: Partial<Store>) {
    return api.put(`/stores/${id}`, data);
}

export function deleteStore(id: number) {
    return api.delete(`/stores/${id}`);
}

export default {
    getStores,
    getStore,
    createStore,
    updateStore,
    deleteStore,
    syncStoresFromPo
};